import { Form } from '@calendly/form'
import { object, string } from '@calendly/form/validation'
import { EMPTY_LINK } from '@calendly/rich-text-editor'


import { Footer, LinkTextField, LinkUrlField, Popup, Body } from './parts'

export const InsertLinkPopup = ({ isOpen, prefilledText, prefilledURL, onClose, onConfirm }) => {
  const initialValues = {
    text: prefilledText,
    url: prefilledURL === EMPTY_LINK ? '' : prefilledURL
  }

  const validationSchema = object({
    url: string().required(),
  })

  const handleConfirm = ({ text, url }) => {
    onConfirm(text, url)
  }

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
    >
      <Form
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleConfirm}
      >
        <Body>
          <LinkTextField />
          <LinkUrlField />
        </Body>
        <Footer
          onClose={onClose}
        />
      </Form>
    </Popup>
  )
}
